import WorkingStatusPage from './WorkingStatusPage';

export default WorkingStatusPage;